<template>
	<div v-if="currentlyViewing" class="achievement-modal-container">
		<h2 class="cheevo-title level-one-heading mb-5">
			{{ currentlyViewing.name }}
			<span class="cheevo-exp">{{ currentlyViewing.experiencePoints }} XP</span>
		</h2>
		<p class="cheevo-desc" v-if="currentlyViewing.isSecret">{{ ta('IS_SECRET') }}</p>
		<p class="cheevo-desc" v-else>{{ currentlyViewing.description }}</p>
		<ximg
			:src="convertToCdnUrl('/img/member/achievements/' + currentlyViewing.imageName + '.png')"
			:fallback="convertToCdnUrl('/img/member/achievements/404.png')"
			:ariaLabel="'achievement image ' + currentlyViewing.name"
			role="img"
		/>
		<p v-if="achievementRarityExplanation" class="rarity-description">
			<img :src="convertToCdnUrl('/img/member/achievements/rarity/' + currentlyViewing.rarity.toLowerCase() + '.png')">
			<span class="text-highlight">{{ currentlyViewing.rarity }}</span>
			({{ achievementRarityExplanation }})
		</p>
	</div>
</template>

<script>
import { t } from 'datastore/i18n';
import { convertToCdnUrl } from 'utils';

export default {
	props: ['achievement'],
	methods: {
		convertToCdnUrl,
		tm: t.prefix('MEMBER'),
		ta: t.prefix('ACHIEVEMENT'),
	},
	computed: {
		achievementRarityExplanation () {
			const ach = this.currentlyViewing;
			if (! ach || ach.rarity == 'N/A') {
				return;
			}
			const rarity = ach.rarityOrder;
			const pre = 'RARITY_';
			if (rarity === 6) {
				return this.ta(pre + 'EXCLUSIVE');
			} else if (rarity === 1) {
				return this.ta(pre + 'MORE_THAN_X', 40);
			}
			return this.ta(pre + 'LESS_THAN_X', [40, 15, 5, 1][rarity - 2]);
		},
		currentlyViewing () {
			return this.achievement;
		},
	},
};
</script>
